import clsx from 'clsx'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { Icon } from '../../'
import LogoWithTagline from '../../../assets/imgs/logo-with-tagline.png'
import { logout } from '../../../store/user'
import './Sidebar.scss'

const Sidebar = ({ isOpen }) => {
   const history = useHistory()
   const dispatch = useDispatch()

   const { isDarkTheme } = useSelector(state => state.theme)

   const handleLogout = () => {
      dispatch(logout())
      history.push('/')
   }

   return (
      <aside
         className={clsx(
            'Sidebar',
            isOpen && 'Sidebar--open',
            isDarkTheme && 'Sidebar--dark'
         )}
      >
         <ul className="Sidebar__list">
            <li className="Sidebar__list-item">
               <Link className="Sidebar__list-item-link" to="/wallet">
                  <Icon
                     name="wallet"
                     color={isDarkTheme ? '#fff' : '#1d1d1d'}
                  />
                  Wallet
               </Link>
            </li>
            <li className="Sidebar__list-item">
               <Link className="Sidebar__list-item-link" to="/watchlist">
                  <Icon
                     name="eye"
                     color={isDarkTheme ? '#fff' : '#1d1d1d'}
                     size={32}
                  />{' '}
                  Watchlist
               </Link>
            </li>
            <li className="Sidebar__list-item">
               <Link className="Sidebar__list-item-link" to="/exchange">
                  <Icon
                     name="exchange"
                     color={isDarkTheme ? '#fff' : '#1d1d1d'}
                  />{' '}
                  Exchange
               </Link>
            </li>
            <li className="Sidebar__list-item">
               <Link className="Sidebar__list-item-link" to="/settings">
                  <Icon name="cog" color={isDarkTheme ? '#fff' : '#1d1d1d'} />{' '}
                  Settings
               </Link>
            </li>
            <li className="Sidebar__list-item" onClick={handleLogout}>
               <Link className="Sidebar__list-item-link" to="#">
                  <Icon
                     name="sign-out"
                     color={isDarkTheme ? '#fff' : '#1d1d1d'}
                     size={32}
                  />{' '}
                  Logout
               </Link>
            </li>
         </ul>
         <img src={LogoWithTagline} alt="WSN" />
      </aside>
   )
}

export default Sidebar
